import { IPharmacy } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { PharmacyWorkItem } from 'src/app/business/institution/pharmacy-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class PharmacyCommandHandler extends EntityCommandHandler<IPharmacy> {
  protected workItem: IWorkItem<IPharmacy>;

  constructor(pharmacyWorkItem: PharmacyWorkItem) {
    super();
    this.workItem = pharmacyWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'PharmacyDto';
  }
}
